export enum ContactType {
  CUSTOMER_CONTACT = 'CUSTOMER_CONTACT',
  BUSINESS_CONTACT = 'BUSINESS_CONTACT',
  QUOTE_CONTACT = 'QUOTE_CONTACT',
  OAUTH_API_CONTACT = 'OAUTH_API_CONTACT',
  BILLING_CONTACT = 'BILLING_CONTACT',
}

export enum CustomerType {
  PARTNER = 'PARTNER',
  DIRECT = 'DIRECT',
}

export enum PatchOperationType {
  ADD = 'add',
  REMOVE = 'remove',
}

export enum PatchOperationPathType {
  PRIMARY = '/isPrimary',
}

export type ContactRelationship = {
  resourceAri: string;
  principalAri: string;
  contactType: string;
};

export type CreateContactRelationshipPayload = {
  customerType: CustomerType;
  contactRelationships: ContactRelationship[];
};

export type CreateContactRelationshipsRequest = {
  payload: CreateContactRelationshipPayload;
  transactionAccountId: string;
};

export type DeleteContactRelationshipsRequest = {
  payload: Array<ContactRelationship & { customerType: CustomerType }>;
  transactionAccountId: string;
};

export type PatchContactRelationshipsRequest = {
  payload: Array<{ op: string; path: string; value: boolean; filter: ContactRelationship }>;
  transactionAccountId: string;
};

export const getResourceAri = (transactionAccountId: string, id: string, contactType?: string) => {
  if (contactType === ContactType.QUOTE_CONTACT) {
    return `ari:cloud:commerce::quote/${id}`;
  }
  return `ari:cloud:commerce:${transactionAccountId}:invoice-group/${id}`;
};

export const getPrincipleAri = (atlassianAccountId: string) => {
  return `ari:cloud:identity::user/${atlassianAccountId}`;
};
